import React from 'react';
import { Check } from '@blueprintnyc/bpnyc-common-admin/dist/icons';

import './NumericalCheck.scss';

const NumericalCheck = ({ number, completed }) => {
	const completedClass = completed ? 'completed' : '';
	return (
		<div className={`NumericalCheck ${completedClass}`}>
			{completed ? <Check fontSize={16} /> : number}
		</div>
	);
};

export default NumericalCheck;
